/**
 * Pull the missing-scope list out of a failed request.
 *
 * The panel's generated SDK does not present errors in one shape — different
 * hooks in this codebase already reach for `error.detail`
 * (`useCustomers.ts`) and `error.response.data.detail`
 * (`usePaymentsAnomalies.ts`). Rather than pick one and be silently wrong,
 * this checks every shape we've actually seen.
 *
 * It keys off the message, not the status code, for the same reason: the
 * status is missing from some of those shapes, and only the scope guard in
 * `require_admin_scopes` produces this sentence. Matching the string is the
 * more reliable signal here, not the lazier one.
 *
 * Returns the missing scopes as a display string, or null if this error was
 * something else entirely.
 */

const PREFIX = "Missing required scope(s): "

type Shape = {
  detail?: unknown
  body?: { detail?: unknown }
  response?: { data?: { detail?: unknown } }
  message?: unknown
}

export function missingScopesFrom(error: unknown): string | null {
  const e = (error ?? {}) as Shape
  const candidates = [
    e.detail,
    e.body?.detail,
    e.response?.data?.detail,
    e.message,
  ]
  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.includes(PREFIX)) {
      return candidate.slice(candidate.indexOf(PREFIX) + PREFIX.length).trim()
    }
  }
  return null
}
